import { useQuery } from "react-query";
import { getCatalogTracks, getRawTracks, } from "frontend/src/api/tracks/get-many";
import { getTrackById, getRawTrackById, } from "frontend/src/api/tracks/get-one-by-id";
import { cacheKey } from "./shared";
export var useTracksSearchResult = function (_a) {
    var params = _a.params;
    var _b = useQuery([cacheKey, params], function () {
        return getCatalogTracks(params);
    }), data = _b.data, isFetching = _b.isFetching, isLoading = _b.isLoading;
    return { data: data, isFetching: isFetching, isLoading: isLoading };
};
export var useRawTracksSearchResult = function (_a) {
    var params = _a.params;
    var _b = useQuery([cacheKey, params], function () {
        return getRawTracks(params);
    }), data = _b.data, isFetching = _b.isFetching, isLoading = _b.isLoading;
    return { data: data, isFetching: isFetching, isLoading: isLoading };
};
// export const useViewerCatalogTracks = ({
//   params,
// }: {
//   params: SearchTracksRequest;
// }) => useQuery([cacheKey, params], () => getCatalogTracks(params));
export var useTrackDetail = function (id) {
    var _a = useQuery([cacheKey, id], function () {
        return getTrackById(id);
    }), data = _a.data, isFetching = _a.isFetching, isLoading = _a.isLoading, remove = _a.remove;
    return { track: data, isFetching: isFetching, isLoading: isLoading, remove: remove };
};
export var useRawTrackDetail = function (id) {
    var _a = useQuery([cacheKey, id], function () {
        return getRawTrackById(id);
    }), data = _a.data, isFetching = _a.isFetching, isLoading = _a.isLoading, remove = _a.remove;
    return { track: data, isFetching: isFetching, isLoading: isLoading, remove: remove };
};
